import { UserRole } from '../../store/user/types';
import {
  AssignableRoles,
  ManagedUser,
  UserCreateRequest,
  UserPartner,
  UserPartnersUpdateRequest,
  UserRolesUpdateRequest,
  UserSearchRequest,
} from './userManagementApiTypes';

const mockManagedUsers: ManagedUser[] = [
  {
    id: 1,
    username: 'admin',
    name: 'Administrator',
    roles: [
      UserRole.SALESCONNECT_ADMIN,
      UserRole.PARTNER_ADMIN,
    ],
    partners: [
      {
        partnerCode: 'Partner',
        partnerName: 'Partner',
      },
      {
        partnerCode: '0002',
        partnerName: 'Shumee',
      },
    ],
    rolesEditable: true,
  },
  {
    id: 2,
    username: 'user',
    name: 'Nice Name',
    roles: [
      UserRole.PARTNER_USER,
    ],
    partners: [
      {
        partnerCode: '0002',
        partnerName: 'Shumee',
      },
    ],
    rolesEditable: true,
  },
  {
    id: 3,
    username: 'other.admin',
    name: 'Other Administrator',
    roles: [
      UserRole.SALESCONNECT_ADMIN,
    ],
    partners: [
      {
        partnerCode: '0000',
        partnerName: 'ProSales, sro',
      },
    ],
    rolesEditable: false,
  },
];

export const mockAssignableRoles: AssignableRoles = {
  roles: [
    UserRole.SALESCONNECT_ADMIN,
    UserRole.PARTNER_ADMIN,
    UserRole.PARTNER_USER,
    UserRole.PARTNER_WAREHOUSE_OPERATIONS,
  ],
};

function findMockUser(url: string | undefined): ManagedUser {
  const userId = Number(url?.split('/')[2]);

  return mockManagedUsers.find(user => user.id === userId) ?? mockManagedUsers[0];
}

function toMockUserPartners(partnerCodes: string[]): UserPartner[] {
  return partnerCodes.map(partnerCode => ({ partnerCode, partnerName: partnerCode }));
}

export function createMockCreatedUser(request: UserCreateRequest): ManagedUser {
  return {
    id: 99,
    username: request.username,
    name: request.name,
    roles: [UserRole.PARTNER_USER],
    partners: toMockUserPartners(request.partnerCodes),
    rolesEditable: true,
  };
}

export function createMockUserWithPartners(
  url: string | undefined,
  request: UserPartnersUpdateRequest,
): ManagedUser {
  return {
    ...findMockUser(url),
    partners: toMockUserPartners(request.partnerCodes),
  };
}

export function createMockUserWithRoles(
  url: string | undefined,
  request: UserRolesUpdateRequest,
): ManagedUser {
  return {
    ...findMockUser(url),
    roles: request.roles,
  };
}

function matchesAny<T>(values: T[], requested: T[] | undefined): boolean {
  if (requested === undefined || requested.length === 0) {
    return true;
  }

  return values.some(value => requested.includes(value));
}

function matchesText(value: string | undefined, requested: string | undefined): boolean {
  return requested === undefined || value === requested;
}

export function findMockUsers(request: UserSearchRequest): ManagedUser[] {
  return mockManagedUsers.filter(user => matchesText(user.username, request.username)
    && matchesText(user.name, request.name)
    && matchesAny(user.partners.map(partner => partner.partnerCode), request.partnerCodes)
    && matchesAny(user.roles, request.roles));
}
